import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import Axios from 'axios';
import { EncryptStorage } from 'encrypt-storage';
import React, { useContext, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import { BudgetContext } from '../../../hooks/ContextStore';
import ActionButton from '../../modules/CustomizeComponent/ActionButton';
import NotifyAttorney from '../DocumentsV2/components/NotifyAttorney';
import BudgetSideNav from './BudgetSideNav';
import GrossEarned from './_partials/GrossEarned/GrossEarned';
import MonthlyDeduction from './_partials/GrossEarned/MonthlyDeduction/MonthlyDeduction';
import MonthlyFinancial from './_partials/GrossEarned/MonthlyFinancial/MonthlyFinancial';
import MonthlySupport from './_partials/GrossEarned/MonthlySupport/MonthlySupport';
import MonthlyLiving from './_partials/GrossEarned/MontlyLiving/MonthlyLiving';

function Budget() {
    const encryptStorage = new EncryptStorage("secret-key");
    const decypt_data = encryptStorage.getItem("case_details");
    const data = decypt_data;
    const client_case_id = data ? data?.case?.id : null;
    const [budget, setBudget] = useContext(BudgetContext);

    useEffect(() => {
        Axios.get("api/budget/stats/" + client_case_id)
        .then((res=>{
            setBudget(res.data)
          }))
          .catch((err) =>{
          })
    }, [client_case_id])

    const handleExportBudget = (event) => {
        event.preventDefault();
          Axios({
            url: process.env.REACT_APP_API_URL +'/excel/budget/current/'+client_case_id,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
             const url = window.URL.createObjectURL(new Blob([response.data]));
             const link = document.createElement('a');
             link.href = url;
             link.setAttribute('download','export-current-budget.xlsx'); //or any other extension
             document.body.appendChild(link);
             link.click();
          });
      };
      
      const handleExportBudgetProjected = (event) => {
        event.preventDefault();
          Axios({
            url: process.env.REACT_APP_API_URL +'/excel/budget/projected/'+client_case_id,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
             const url = window.URL.createObjectURL(new Blob([response.data]));
             const link = document.createElement('a');
             link.href = url;
             link.setAttribute('download','export-projected-budget.xlsx'); //or any other extension
             document.body.appendChild(link);
             link.click();
          });
      };
  
    return (
        <>
        <div className="col-12 p-1 bg-white border-0 d-flex mb-7 align-items-center rounded">
            <div className="budget px-5">
                <h3>Budget</h3>
                <h3 className="text-muted font-weight-bold font-size-sm">Information About Income and Financial Needs</h3>
            </div>
            <div className="ml-auto"> 
            <Box display="flex"  justifyContent="flex-end" m={1} p={1}>

            <form onSubmit={handleExportBudget}>
                <ActionButton  className='btn btn-primary m-2' type="submit" variant="btn btn-primary">
                    Export Current Budget to Excel
                </ActionButton>
            </form>
            <form onSubmit={handleExportBudgetProjected}>
                <ActionButton  className='btn btn-primary m-2' type="submit" variant="btn btn-primary">
                Export Projected Budget to Excel

                </ActionButton>
            </form>
            
            <div className='align-self-center'>
                <NotifyAttorney />
            </div>
        
            </Box>
            </div>
        </div>

        <div>
        
        <div class="row">
            <div class="col-xl-3">
                <div class="card card-custom bg-white card-stretch gutter-b">
                    <div class="card-body">
                    <span class="symbol symbol-50 symbol-light-success mr-2">
                            <span class="symbol-label">
                                <span class="svg-icon svg-icon-xl svg-icon-success">
                                    <svg xmlns="http://www.w3.org/2000/svg"  width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g id="Stockholm-icons-/-Shopping-/-Dollar" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                                        <rect id="Rectangle" fill="#000000" opacity="0.3" x="11.5" y="2" width="2" height="4" rx="1"></rect>
                                        <rect id="Rectangle-Copy-3" fill="#000000" opacity="0.3" x="11.5" y="16" width="2" height="5" rx="1"></rect>
                                        <path d="M15.493,8.044 C15.2143319,7.68933156 14.8501689,7.40750104 14.4005,7.1985 C13.9508311,6.98949895 13.5170021,6.885 13.099,6.885 C12.8836656,6.885 12.6651678,6.90399981 12.4435,6.942 C12.2218322,6.98000019 12.0223342,7.05283279 11.845,7.1605 C11.6676658,7.2681672 11.5188339,7.40749914 11.3985,7.5785 C11.2781661,7.74950085 11.218,7.96799867 11.218,8.234 C11.218,8.46200114 11.2654995,8.65199924 11.3605,8.804 C11.4555005,8.95600076 11.5948324,9.08899943 11.7785,9.203 C11.9621676,9.31700057 12.1806654,9.42149952 12.434,9.5165 C12.6873346,9.61150047 12.9723317,9.70966616 13.289,9.811 C13.7450023,9.96300076 14.2199975,10.1308324 14.714,10.3145 C15.2080025,10.4981676 15.6576646,10.7419985 16.063,11.046 C16.4683354,11.3500015 16.8039987,11.7268311 17.07,12.1765 C17.3360013,12.6261689 17.469,13.1866633 17.469,13.858 C17.469,14.6306705 17.3265014,15.2988305 17.0415,15.8625 C16.7564986,16.4261695 16.3733357,16.8916648 15.892,17.259 C15.4106643,17.6263352 14.8596698,17.8986658 14.239,18.076 C13.6183302,18.2533342 12.97867,18.342 12.32,18.342 C11.3573285,18.342 10.4263378,18.1741683 9.527,17.8385 C8.62766217,17.5028317 7.88033631,17.0246698 7.285,16.404 L9.413,14.238 C9.74233498,14.6433354 10.176164,14.9821653 10.7145,15.2545 C11.252836,15.5268347 11.7879973,15.663 12.32,15.663 C12.5606679,15.663 12.7949989,15.6376669 13.023,15.587 C13.2510011,15.5363331 13.4504991,15.4540006 13.6215,15.34 C13.7925009,15.2259994 13.9286662,15.0740009 14.03,14.884 C14.1313338,14.693999 14.182,14.4660013 14.182,14.2 C14.182,13.9466654 14.1186673,13.7313342 13.992,13.554 C13.8653327,13.3766658 13.6848345,13.2151674 13.4505,13.0695 C13.2161655,12.9238326 12.9248351,12.7908339 12.5765,12.6705 C12.2281649,12.5501661 11.8323355,12.420334 11.389,12.281 C10.9583312,12.141666 10.5371687,11.9770009 10.1255,11.787 C9.71383127,11.596999 9.34650161,11.3531682 9.0235,11.0555 C8.70049838,10.7578318 8.44083431,10.3968355 8.2445,9.9725 C8.04816568,9.54816454 7.95,9.03200304 7.95,8.424 C7.95,7.67666293 8.10199848,7.03700266 8.406,6.505 C8.71000152,5.97299734 9.10899753,5.53600171 9.603,5.194 C10.0970025,4.85199829 10.6543302,4.60183412 11.275,4.4435 C11.8956698,4.28516587 12.5226635,4.206 13.156,4.206 C13.9160038,4.206 14.6918294,4.34533194 15.4835,4.624 C16.2751706,4.90266806 16.9686637,5.31433061 17.564,5.859 L15.493,8.044 Z" id="Combined-Shape" fill="#000000"></path>
                                    </g>
                                    </svg>
                                </span>
                            </span>
                        </span>
                        <span class="card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 mt-6 d-block">$ {budget?String(budget?.total_gross_income||0).replace(/\B(?=(\d{3})+(?!\d))/g, ","):<Skeleton height={15} width={50} variant="rect" />}
                       </span>
                        <span class="font-weight-bold text-muted font-size-sm">Total Gross Income</span>
                    </div>
                </div>
            </div>
            <div class="col-xl-3">
                <div class="card card-custom  bg-white card-stretch gutter-b">
                    <div class="card-body">
                    <span class="symbol symbol-50 symbol-light-success mr-2">
                            <span class="symbol-label">
                                <span class="svg-icon svg-icon-xl svg-icon-success">
                                    <svg xmlns="http://www.w3.org/2000/svg"  width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g id="Stockholm-icons-/-Shopping-/-Wallet2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                                        <rect id="Rectangle-2" fill="#000000" opacity="0.3" x="2" y="2" width="10" height="12" rx="2"></rect>
                                        <path d="M4,6 L20,6 C21.1045695,6 22,6.8954305 22,8 L22,20 C22,21.1045695 21.1045695,22 20,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,8 C2,6.8954305 2.8954305,6 4,6 Z M18,16 C19.1045695,16 20,15.1045695 20,14 C20,12.8954305 19.1045695,12 18,12 C16.8954305,12 16,12.8954305 16,14 C16,15.1045695 16.8954305,16 18,16 Z" id="Combined-Shape" fill="#000000"></path>
                                    </g>
                                    </svg>
                                </span>
                            </span>
                        </span>
                        <span class="card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 mt-6 d-block">  $ {budget?String(budget?.total_net_income||0).replace(/\B(?=(\d{3})+(?!\d))/g, ","):<Skeleton height={15} width={50} variant="rect" />}</span>
                        <span class="font-weight-bold text-muted font-size-sm">Total Net Income</span>
                    </div>
                </div>
            </div>
            <div class="col-xl-3">
                <div class="card card-custom  bg-white card-stretch gutter-b">
                    <div class="card-body">
                    <span class="symbol symbol-50 symbol-light-success mr-2">
                            <span class="symbol-label">
                                <span class="svg-icon svg-icon-xl svg-icon-success">
                                    <svg xmlns="http://www.w3.org/2000/svg"  width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g id="Stockholm-icons-/-Shopping-/-Cart2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                                        <path d="M12,4.56204994 L7.76822128,9.6401844 C7.4146572,10.0644613 6.7840925,10.1217854 6.3598156,9.76822128 C5.9355387,9.4146572 5.87821464,8.7840925 6.23177872,8.3598156 L11.2317787,2.3598156 C11.6315738,1.88006147 12.3684262,1.88006147 12.7682213,2.3598156 L17.7682213,8.3598156 C18.1217854,8.7840925 18.0644613,9.4146572 17.6401844,9.76822128 C17.2159075,10.1217854 16.5853428,10.0644613 16.2317787,9.6401844 L12,4.56204994 Z" id="Path-30" fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
                                        <path d="M3.28077641,9 L20.7192236,9 C21.2715083,9 21.7192236,9.44771525 21.7192236,10 C21.7192236,10.0817618 21.7091962,10.163215 21.6893661,10.2425356 L19.5680983,18.7276069 C19.234223,20.0631079 18.0342737,21 16.6576708,21 L7.34232922,21 C5.96572629,21 4.76577697,20.0631079 4.43190172,18.7276069 L2.31063391,10.2425356 C2.17668518,9.70674072 2.50244587,9.16380623 3.03824078,9.0298575 C3.11756139,9.01002735 3.1990146,9 3.28077641,9 Z M12,12 C11.4477153,12 11,12.4477153 11,13 L11,17 C11,17.5522847 11.4477153,18 12,18 C12.5522847,18 13,17.5522847 13,17 L13,13 C13,12.4477153 12.5522847,12 12,12 Z M6.96472382,12.1362967 C6.43125772,12.2792385 6.11467523,12.8275755 6.25761704,13.3610416 L7.29289322,17.2247449 C7.43583503,17.758211 7.98417199,18.0747935 8.51763809,17.9318517 C9.05110419,17.7889098 9.36768668,17.2405729 9.22474487,16.7071068 L8.18946869,12.8434035 C8.04652688,12.3099374 7.49818992,11.9933549 6.96472382,12.1362967 Z M17.0352762,12.1362967 C16.5018101,11.9933549 15.9534731,12.3099374 15.8105313,12.8434035 L14.7752551,16.7071068 C14.6323133,17.2405729 14.9488958,17.7889098 15.4823619,17.9318517 C16.015828,18.0747935 16.564165,17.758211 16.7071068,17.2247449 L17.742383,13.3610416 C17.8853248,12.8275755 17.5687423,12.2792385 17.0352762,12.1362967 Z" id="Combined-Shape" fill="#000000"></path>
                                    </g>
                                    </svg>
                                </span>
                            </span>
                        </span>
                        <span class="card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 mt-6 d-block">  $ {budget?String(budget?.total_expenses||0).replace(/\B(?=(\d{3})+(?!\d))/g, ","):<Skeleton height={15} width={50} variant="rect" />}</span>
                        <span class="font-weight-bold text-muted font-size-sm">Total Expenses</span>
                    </div>
                </div>
            </div>
            <div class="col-xl-3">
                <div class="card card-custom  bg-white card-stretch gutter-b">
                    <div class="card-body">
                    <span class="symbol symbol-50 symbol-light-success mr-2">
                            <span class="symbol-label">
                                <span class="svg-icon svg-icon-xl svg-icon-success">
                                    <svg xmlns="http://www.w3.org/2000/svg"  width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g id="Stockholm-icons-/-Shopping-/-Calculator" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                                        <rect id="Rectangle-189-Copy" fill="#000000" opacity="0.3" x="7" y="4" width="10" height="4"></rect>
                                        <path d="M7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,20 C19,21.1045695 18.1045695,22 17,22 L7,22 C5.8954305,22 5,21.1045695 5,20 L5,4 C5,2.8954305 5.8954305,2 7,2 Z M8,12 C8.55228475,12 9,11.5522847 9,11 C9,10.4477153 8.55228475,10 8,10 C7.44771525,10 7,10.4477153 7,11 C7,11.5522847 7.44771525,12 8,12 Z M8,16 C8.55228475,16 9,15.5522847 9,15 C9,14.4477153 8.55228475,14 8,14 C7.44771525,14 7,14.4477153 7,15 C7,15.5522847 7.44771525,16 8,16 Z M12,12 C12.5522847,12 13,11.5522847 13,11 C13,10.4477153 12.5522847,10 12,10 C11.4477153,10 11,10.4477153 11,11 C11,11.5522847 11.4477153,12 12,12 Z M12,16 C12.5522847,16 13,15.5522847 13,15 C13,14.4477153 12.5522847,14 12,14 C11.4477153,14 11,14.4477153 11,15 C11,15.5522847 11.4477153,16 12,16 Z M16,12 C16.5522847,12 17,11.5522847 17,11 C17,10.4477153 16.5522847,10 16,10 C15.4477153,10 15,10.4477153 15,11 C15,11.5522847 15.4477153,12 16,12 Z M16,16 C16.5522847,16 17,15.5522847 17,15 C17,14.4477153 16.5522847,14 16,14 C15.4477153,14 15,14.4477153 15,15 C15,15.5522847 15.4477153,16 16,16 Z M16,20 C16.5522847,20 17,19.5522847 17,19 C17,18.4477153 16.5522847,18 16,18 C15.4477153,18 15,18.4477153 15,19 C15,19.5522847 15.4477153,20 16,20 Z M8,18 C7.44771525,18 7,18.4477153 7,19 C7,19.5522847 7.44771525,20 8,20 L12,20 C12.5522847,20 13,19.5522847 13,19 C13,18.4477153 12.5522847,18 12,18 L8,18 Z M7,4 L7,8 L17,8 L17,4 L7,4 Z" id="Combined-Shape" fill="#000000"></path>
                                    </g>
                                    </svg>
                                </span>
                            </span>
                        </span>
                        <span class="card-title font-weight-bolder text-dark-75 font-size-h2 mb-0 mt-6 d-block">  $ {budget? String(budget?.shortfall||0).replace(/\B(?=(\d{3})+(?!\d))/g, ","):<Skeleton height={15} width={50} variant="rect" />}</span>
                        <span class="font-weight-bold text-muted font-size-sm">Shortfall/Surplus</span>
                    </div>
                </div>
            </div>
        </div>

        </div>

        <div className="d-flex flex-row">
            <BudgetSideNav/>
            <div className="flex-row-fluid ml-lg-8">
            <Switch>
                <Route
                    path="/budget/gross-income"
                    exact={true}
                    component={GrossEarned}
                />
                 <Route
                    path="/budget/monthly-deduction"
                    component={MonthlyDeduction}
                />
                   <Route
                    path="/budget/monthly-support"
                    component={MonthlySupport}
                />
                
                <Route
                    path="/budget/monthly-financial-expense"
                    component={MonthlyFinancial}
                />
                     <Route
                    path="/budget/monthly-living-expense"
                    component={MonthlyLiving}
                />
                
            </Switch>
            </div>
        </div>

        </>
    )
}

export default Budget
